import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import { useAuth } from '../hooks/useAuth';

const LoginPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/tasks/list');
    }
  }, [user, navigate]);

  return (
    <div className="login-container">
      <div className="login-image-section">
        <div className="login-overlay">
          <div className="login-image-content">
            <h1>Welcome to Admin Dashboard</h1>
           
          </div>
        </div>
      </div>
      <div className="login-form-section">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;